import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import getEntityById from '../selectors/getEntityById'

class RootPath extends Component {
  componentDidMount () {
    const {
      rootItem,
      history
    } = this.props

    history.push(`${rootItem.type}/${rootItem.id}`)
  }

  render () {
    return null
  }
}

RootPath.propTypes = {
  history: PropTypes.object,
  rootItem: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    rootItem: getEntityById(state, 'settings', 'rootItem')
  }
}

export default connect(mapStateToProps)(RootPath)



// WEBPACK FOOTER //
// ./src/components/RootPath.js